<script setup lang="ts">
import { useVModel } from '@vueuse/core';
import { computed, ref, watch } from 'vue';

import Select from '@/components/base/form/OutlinedSelect.vue';
import { orderTags } from '@/composables/usePayment';

const emit = defineEmits<{ 'update:modelValue': [string[] | undefined] }>();
const props = defineProps<{ modelValue?: string[] }>();

const selectedOrderTags = useVModel(props, 'modelValue', emit);

const dropdownOrderTags = selectedOrderTags.value?.filter((t) => t !== 'Reshipment') ?? [];
const selectedOrderTag = ref(dropdownOrderTags.shift());

const updateSelection = () => {
  const tags: string[] = [];
  if (selectedOrderTag.value) {
    tags.push(selectedOrderTag.value);
  }
  selectedOrderTags.value = tags;
};

const options = computed(() =>
  [{ label: '', value: '' }].concat(
    orderTags.map((orderTag) => ({
      label: orderTag,
      value: orderTag,
    })),
  ),
);

watch(selectedOrderTag, () => updateSelection());
watch(
  selectedOrderTags,
  () => {
    if (selectedOrderTags.value?.length === 0) {
      selectedOrderTag.value = undefined;
    }
  },
  { deep: true },
);
</script>

<template>
  <div class="w-full mt-2" data-test="order-tags-selection">
    <label class="w-full text-base font-normal cursor-pointer" data-test="order-tags-list">
      <Select
        v-model="selectedOrderTag"
        class="h-auto py-2 pl-5 pr-12 font-proxima-nova"
        :options="options"
        name="order-tags"
        aria-label="select order tag"
        data-test="select-order-tag"
      />
    </label>
  </div>
</template>
